import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "customer-uploads-page" };
const _hoisted_2 = { class: "page-header" };
const _hoisted_3 = { class: "subtitle" };
const _hoisted_4 = {
    key: 0,
    class: "loading-overlay"
};
const _hoisted_5 = {
    key: 1,
    class: "documents-section"
};
const _hoisted_6 = {
    key: 0,
    class: "simple-table"
};
const _hoisted_7 = ["href"];
const _hoisted_8 = { key: 1 };
const _hoisted_9 = ["onClick"];
const _hoisted_10 = {
    key: 1,
    class: "empty-state"
};
const _hoisted_11 = {
    key: 0,
    class: "modal-content"
};
const _hoisted_12 = { class: "modal-image-container" };
const _hoisted_13 = ["src"];
const _hoisted_14 = { class: "modal-json" };
import { ref, onMounted } from 'vue';
import { useAdmin } from '@/composables/useAdmin';
import MGDialog from '@/components/elements/MGDialog.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'CustomerUploadsPage',
    setup(__props) {
        const admin = useAdmin();
        const documents = ref([]);
        const customers = ref([]);
        const loading = ref(true);
        const reprocessingId = ref(null);
        const showDocumentModal = ref(false);
        const selectedDocument = ref(null);
        function formatDateTime(dateString) {
            if (!dateString)
                return '-';
            const date = new Date(dateString);
            return date.toLocaleString('en-GB', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit'
            });
        }
        function formatProcessedTime(dateString) {
            if (!dateString)
                return '-';
            const date = new Date(dateString);
            return date.toLocaleTimeString('en-GB', {
                hour: '2-digit',
                minute: '2-digit'
            });
        }
        const documentColumns = ref([
            {
                key: 'createDateTime',
                label: 'Added',
                formatter: (doc) => formatDateTime(doc.createDateTime)
            },
            { key: 'email', label: 'Customer' },
            {
                key: 'processedDateTime',
                label: 'Processed',
                formatter: (doc) => formatProcessedTime(doc.processedDateTime)
            }
        ]);
        function canRetry(document) {
            return !!document.processedDateTime;
        }
        function retryProcessing(documentId) {
            reprocessingId.value = documentId;
            admin.retryDocument(documentId, null, () => {
                showToast('Document reprocessing initiated');
                reprocessingId.value = null;
                loadDocuments();
            }, (error) => {
                showError(error);
                reprocessingId.value = null;
            });
        }
        function loadDocuments() {
            loading.value = true;
            admin.getCustomers((customersData) => {
                customers.value = customersData || [];
                admin.getDocuments((documentsData) => {
                    documents.value = documentsData || [];
                    documents.value.forEach((doc) => {
                        const customer = customers.value.find((c) => c.id === doc.customerId);
                        if (customer) {
                            doc.email = customer.person.email;
                        }
                    });
                    loading.value = false;
                });
            });
        }
        function openDocumentModal(document) {
            selectedDocument.value = document;
            showDocumentModal.value = true;
        }
        function showToast(message) {
            console.log('Toast:', message);
        }
        function showError(message) {
            console.error('Error:', message);
        }
        onMounted(() => {
            loadDocuments();
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _cache[2] || (_cache[2] = _createElementVNode("h1", null, "Customer Uploads", -1)),
                    _createElementVNode("p", _hoisted_3, "Showing " + _toDisplayString(documents.value.length) + " recent document(s)", 1)
                ]),
                (loading.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, _cache[3] || (_cache[3] = [
                        _createElementVNode("div", { class: "spinner" }, null, -1),
                        _createElementVNode("p", null, "Loading documents...", -1)
                    ])))
                    : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        (documents.value && documents.value.length > 0)
                            ? (_openBlock(), _createElementBlock("table", _hoisted_6, [
                                _createElementVNode("thead", null, [
                                    _createElementVNode("tr", null, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(documentColumns.value, (col) => {
                                            return (_openBlock(), _createElementBlock("th", {
                                                key: col.key
                                            }, _toDisplayString(col.label), 1));
                                        }), 128)),
                                        _cache[4] || (_cache[4] = _createElementVNode("th", null, "Doc", -1)),
                                        _cache[5] || (_cache[5] = _createElementVNode("th", null, "Details", -1))
                                    ])
                                ]),
                                _createElementVNode("tbody", null, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(documents.value, (doc, idx) => {
                                        return (_openBlock(), _createElementBlock("tr", { key: idx }, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(documentColumns.value, (col) => {
                                                return (_openBlock(), _createElementBlock("td", {
                                                    key: col.key
                                                }, _toDisplayString(col.formatter ? col.formatter(doc) : (doc[col.key] || '-')), 1));
                                            }), 128)),
                                            _createElementVNode("td", null, [
                                                (doc.url)
                                                    ? (_openBlock(), _createElementBlock("a", {
                                                        key: 0,
                                                        href: doc.url,
                                                        target: "_blank",
                                                        class: "folder-link",
                                                        title: "Open document"
                                                    }, "📁", 8, _hoisted_7))
                                                    : (_openBlock(), _createElementBlock("span", _hoisted_8, "-"))
                                            ]),
                                            _createElementVNode("td", null, [
                                                _createElementVNode("button", {
                                                    class: "btn-expand",
                                                    onClick: ($event) => (openDocumentModal(doc)),
                                                    title: "Show details"
                                                }, "+", 8, _hoisted_9)
                                            ])
                                        ]));
                                    }), 128))
                                ])
                            ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_10, " No documents found "))
                    ])),
                _createVNode(MGDialog, {
                    modelValue: showDocumentModal.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((showDocumentModal).value = $event)),
                    title: "Document Details",
                    "max-width": "1200px",
                    contentHeight: "700px"
                }, {
                    content: _withCtx(() => [
                        (selectedDocument.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                _createElementVNode("div", _hoisted_12, [
                                    _createElementVNode("img", {
                                        class: "modal-image",
                                        src: selectedDocument.value.url
                                    }, null, 8, _hoisted_13)
                                ]),
                                _createElementVNode("pre", _hoisted_14, _toDisplayString(JSON.stringify(selectedDocument.value, null, 2)), 1)
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    actions: _withCtx(() => [
                        _createElementVNode("button", {
                            class: "action-btn secondary",
                            onClick: _cache[0] || (_cache[0] = ($event) => (showDocumentModal.value = false))
                        }, "Close")
                    ]),
                    _: 1
                }, 8, ["modelValue"])
            ]));
        };
    }
});
